"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var sales_force_auto_complete_1 = __importDefault(require("../../utils/sales_force/sales_force_auto_complete"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var OpportunityMediumPre = /** @class */ (function (_super) {
    __extends(OpportunityMediumPre, _super);
    function OpportunityMediumPre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            mediumPrice: '',
            mediumContractState: '',
            mediumRequestStartDate: null,
            mediumContractEdate: null,
            mediumItPeriod: '',
            mediumBunkatuFlg: '',
            mediumItFlg: '',
            mediumTokubetuFlg: '',
            mediumTokubetuDetail: '',
            opportunityMediumId: '',
            opportunityMediumName: '',
            mediumContractStartDate: null,
            mediumPriceBook2Id: '',
            mediumProductId: '',
            opportunityMediumItemId: '',
            mediumPriceBook2Name: '',
            mediumPriceBook2Description: '',
            mediumProductName: '',
            mediumPriceDefault: '',
            mediumPriceBookData: [],
            mediumProductPlanName: '',
            mediumPriceBookUrl: '',
            mediumPriceBookMonth: '',
            mediumPriceBookBillWay: '',
            applyInfoApplyCapacityMedium: '',
            applyInfoMediumStartDate: ''
        };
        _this.mediumPrice = '';
        _this.mediumItFlgDisabled = false;
        _this.mediumItFlgDescription = false;
        return _this;
    }
    OpportunityMediumPre.prototype.mediumPriceChange = function (newPrice) {
        this.mediumPrice = String(newPrice);
        this.salesForceInfo.mediumPriceDefault = this.mediumPrice;
        this.salesForceInfo.mediumPrice = this.mediumPrice;
    };
    OpportunityMediumPre.prototype.priceBookChange = function (newBookInfo) {
        this.salesForceInfo.mediumPriceBook2Name = newBookInfo['name'];
        this.salesForceInfo.mediumPriceBook2Description = newBookInfo['description'];
        this.salesForceInfo.mediumPriceBookUrl = newBookInfo['url'];
        this.salesForceInfo.mediumPriceBookBillWay = newBookInfo['BillWay'];
        if (this.isStandardPriceBook(this.salesForceInfo.mediumPriceBook2Id)) {
            this.salesForceInfo.mediumProductId = '';
        }
    };
    OpportunityMediumPre.prototype.productChange = function (newProductInfo) {
        this.salesForceInfo.mediumProductName = newProductInfo['name'];
        this.salesForceInfo.mediumProductPlanName = newProductInfo['planName'];
        this.salesForceInfo.mediumPriceBookMonth = newProductInfo['month'];
        this.salesForceInfo.applyInfoApplyCapacityMedium = newProductInfo['capacity'];
        // IT補助金対応商品選択時
        // if (this.salesForceInfo.mediumProductPlanName === '2年') {
        //     this.salesForceInfo.mediumItFlg = 'true';
        //     this.mediumItFlgDisabled = true;
        //     this.mediumItFlgDescription = true;
        // } else {
        //     this.salesForceInfo.mediumItFlg = null;
        //     this.mediumItFlgDisabled = false;
        //     this.mediumItFlgDescription = false;
        // }
    };
    OpportunityMediumPre.prototype.mediumChange = function (newProductItems) {
        this.salesForceInfo.mediumPriceBookData = newProductItems;
    };
    OpportunityMediumPre.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityMediumPre.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityMediumPre.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityMediumPre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityMediumPre.prototype.isStandardPriceBook = function (priceBookId) {
        return price_book_utils_1.default.isStandardPriceBook(priceBookId);
    };
    OpportunityMediumPre.prototype.isNotStandardPriceBook = function (priceBookId) {
        return !this.isStandardPriceBook(priceBookId);
    };
    OpportunityMediumPre.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.mediumRequestStartDate)) {
            this.salesForceInfo.mediumRequestStartDate = sales_force_auto_complete_1.default.getRequestStartDate(this.salesForceInfo.mediumContractStartDate);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.mediumContractEdate)) {
            this.salesForceInfo.mediumContractEdate = sales_force_auto_complete_1.default.getContractEdate(this.salesForceInfo.mediumContractStartDate, this.form.applyInfoMediumPeriod);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityMediumName)) {
            this.salesForceInfo.opportunityMediumName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
        // IT補助金対応商品選択時
        // if (ValueChecker.isPresent(this.salesForceInfo.mediumProductPlanName) && this.salesForceInfo.mediumProductPlanName === '2年') {
        //     this.salesForceInfo.mediumItFlg = 'true';
        //     this.mediumItFlgDisabled = true;
        //     this.mediumItFlgDescription = true;
        // }
    };
    OpportunityMediumPre.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityMediumPre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityMediumPre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, errorMessage;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.mediumPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.mediumProductId)) &&
                    this.isNotStandardPriceBook(self_.salesForceInfo.mediumPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_product_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.mediumPrice)) &&
                    this.isNotStandardPriceBook(self_.salesForceInfo.mediumPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_price').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.applyInfoMediumStartDate)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.arert_start_date').toString();
                    return [2 /*return*/];
                }
                if (this.isPriceDifferent() && this.isTokubetuBlank()) {
                    errorMessage = "<div class=\"col\">" +
                        this.$t('view.sales_force.reflect.msg.price_error') +
                        ("<br>\u6A19\u6E96\u4FA1\u683C: <strong>" + this.mediumPrice + "</strong><br>") +
                        ("\u8CA9\u58F2\u4FA1\u683C: <strong>" + this.salesForceInfo.mediumPrice + "</strong><br>");
                    this.showAlertDialog = true;
                    this.alertMessage = errorMessage;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.mediumBunkatuFlg) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.bunkatu_error'));
                    return [2 /*return*/];
                }
                if (price_book_utils_1.default.isAbnormal(self_.salesForceInfo.mediumPriceBook2Id, false) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.tokubetu_error'));
                    return [2 /*return*/];
                }
                this.confirmMessage = '<strong>申込予定のRehab Cloud Mediumの商品</strong>を登録します。よろしいですか？';
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityMediumPre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityMediumPre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityMediumPre.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityMediumPre.prototype.isPriceDifferent = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.mediumPrice)) {
            return false;
        }
        return String(this.mediumPrice) !== String(this.salesForceInfo.mediumPrice);
    };
    OpportunityMediumPre.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.mediumTokubetuDetail);
    };
    OpportunityMediumPre.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityMediumId) {
            this.salesForceInfo.opportunityMediumId = '';
        }
        if (!this.salesForceInfo.opportunityMediumItemId) {
            this.salesForceInfo.opportunityMediumItemId = '';
        }
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                mediumPrice: this.salesForceInfo.mediumPrice,
                mediumContractState: this.salesForceInfo.mediumContractState,
                mediumRequestStartDate: this.salesForceInfo.mediumRequestStartDate,
                mediumContractEdate: this.salesForceInfo.mediumContractEdate,
                mediumItPeriod: this.salesForceInfo.mediumItPeriod,
                mediumBunkatuFlg: this.salesForceInfo.mediumBunkatuFlg,
                mediumItFlg: this.salesForceInfo.mediumItFlg,
                mediumTokubetuFlg: this.salesForceInfo.mediumTokubetuFlg,
                mediumTokubetuDetail: this.salesForceInfo.mediumTokubetuDetail,
                opportunityMediumId: this.salesForceInfo.opportunityMediumId.trim(),
                opportunityMediumName: this.salesForceInfo.opportunityMediumName,
                mediumContractStartDate: this.salesForceInfo.mediumContractStartDate,
                mediumPriceBook2Id: this.salesForceInfo.mediumPriceBook2Id,
                opportunityMediumItemId: this.salesForceInfo.opportunityMediumItemId.trim(),
                mediumPriceBook2Description: this.salesForceInfo.mediumPriceBook2Description,
                mediumPriceBook2Name: this.salesForceInfo.mediumPriceBook2Name,
                mediumProductName: this.salesForceInfo.mediumProductName,
                mediumPriceDefault: this.salesForceInfo.mediumPriceDefault,
                mediumPriceBookData: this.salesForceInfo.mediumPriceBookData,
                mediumProductPlanName: this.salesForceInfo.mediumProductPlanName,
                mediumPriceBookUrl: this.salesForceInfo.mediumPriceBookUrl,
                mediumPriceBookMonth: this.salesForceInfo.mediumPriceBookMonth,
                // mediumPriceBookBillWay: this.salesForceInfo.mediumPriceBookBillWay,
                applyInfoMediumStartDate: this.salesForceInfo.applyInfoMediumStartDate
            },
            reflectType: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_MEDIUM_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_MEDIUM_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityMediumPre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityMediumPre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityMediumPre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityMediumPre.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], OpportunityMediumPre.prototype, "isLinkComplete", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityMediumPre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityMediumPre.prototype, "initSalesForceDataChange", null);
    OpportunityMediumPre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityMediumPre);
    return OpportunityMediumPre;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityMediumPre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityMediumPre.vue
// module id = F36F
// module chunks = 1